<li class="list-group-item" cdkDragLockAxis="y" cdkDrag>
    <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
    <div class="preset-option d-flex">
        <div class="preset-option__drag-and-drop cursor--pointer d-flex align-items-center justify-content-center">
            <app-icon-menu></app-icon-menu>
        </div>
        <div [formGroup]="button" class="preset-option__content d-flex align-items-center">
            <div class="preset-option__container">
                <button class="btn btn--paybee btn-xs modal-outline-button text-center">{{ registration.label }}</button>
            </div>
            <div class="d-flex">
                <div class="preset-option__action cursor--pointer d-flex align-items-center justify-content-center">
                <app-icon-pen (click)="editRegistrationButton(registration, index)"></app-icon-pen>
                </div>
                <div (click)="removeOption(registration.id)" class="preset-option__action cursor--pointer d-flex align-items-center justify-content-center">
                <app-icon-trash></app-icon-trash>
                </div>
            </div>
        </div>
    </div>
</li>
